import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import QueryString from 'query-string';
import ReactTable from 'react-table';
import Select from "react-select";
import i18next from 'i18next';

import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { RowButton } from '../RowButton';
import { AccessHelper, BaseTable } from '../../helpers';
import { ChecklistUserService, GroupingsService } from '../../services';

@connect(state => {
    return {
      me: state.user.me,
      currentGrouping: state.currentGrouping.currentGrouping
    }
  })
class ChecklistUsers extends React.Component {
    constructor(props) {
        super(props);

        const passedState = this.props.history?.location?.state ? this.props.history.location.state : null;        

        this.DEFAULT_SORTED = [];

        this.state = {
          linkTo: null,
          localErrorHandler: this.handleLocalError.bind(this),
          localErrorMessage: null,
          hasError: false,  
          data: [],
          pageCount: null,
          forcePage: null,
          totalElements: null,
          loading: true,
          parsedOptions: QueryString.parse(this.props.location.search),
          currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
          viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/checklist/users/view/:checklistUserId'),
          editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/checklist/users/edit/:checklistUserId'),
          groupingFilterOptions: passedState ? passedState.groupingFilterOptions : null,
          groupingFilterValue: passedState ? passedState.currentGroupingFilter : null,
          searchValue: passedState && passedState.searchValue ? passedState.searchValue : '',
        };
    }

    componentDidMount() {
      const parsedOptions = this.state.parsedOptions ? this.state.parsedOptions : {};
      
      if (this.state.groupingFilterOptions == null) {
        GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then(response => {
          const groupingFilterOptions = response.groupings;
          let groupingFilterValue = null;
          if (this.state.groupingFilterValue) {
            groupingFilterValue = this.state.groupingFilterValue;
          } else if (parsedOptions['filterByGroupingId']) {
            let filteredGrouping = response.groupings.filter(group =>
              group.options.some(grouping => grouping.value == parsedOptions['filterByGroupingId'])).map(group => {
              let newGroup = Object.assign({}, group);
              return newGroup.options.filter(grouping => grouping.value == parsedOptions['filterByGroupingId'])
            });
            groupingFilterValue = filteredGrouping[0][0];
          }
          this.setState({
            groupingFilterOptions: groupingFilterOptions,
            groupingFilterValue: groupingFilterValue
          });
        }).catch(error => {
          console.error(error);
          this.state.localErrorHandler(error.message);
        });
      }
    }

    messageDismissCallback() {
        this.setState({ localErrorMessage: null });
      }
    
    renderMessages() {
        if (this.state.localErrorMessage) {
            return (
                <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
            );
        }

        if (this.props.location.state) {
            return (
                <Message messages={this.props.location} />
            );
        }
        return null;
    }

    handleLocalError(localErrorMessage) {
        this.setState({ localErrorMessage: localErrorMessage });
      }

    viewLinkClick(rowId) {
        this.setState({ linkTo: `/config/checklist/users/view/${rowId}` });
    }
    
      editLinkClick(rowId) {
        this.setState({ linkTo: `/config/checklist/users/edit/${rowId}` });
    }

    fetchData(tableData) {
        if (this.updateRequestURL(tableData)) {
          return;
        }
    
        this.setState({
          loading: true
        });

        if (!this.state.groupingFilterOptions) {
          return;
        }
    
       let options = BaseTable.buildFetchDataOptions(this.state.parsedOptions, this.DEFAULT_SORTED);

       if (this.state.searchValue) {
         options.push({search: this.state.searchValue});
       }

        ChecklistUserService.getAll(options).then(response => {
          const pageCount = Math.ceil(response.page.totalElements / this.refs.checklistUsersTable.state.pageSize);

          let forcePage = null;
          if (this.refs.checklistUsersTable && this.refs.checklistUsersTable.state
            && this.refs.checklistUsersTable.state.page >= pageCount && pageCount > 0) {
            forcePage = pageCount - 1;
          }

          this.setState({
            data: response.checklistUsers,
            pageCount: pageCount,
            forcePage: forcePage,
            totalElements: response.page.totalElements,
            loading: false
          });
        }).catch(error => {
          console.error(error);
          this.setState({ hasError: true });
          this.state.localErrorHandler(error.message);
        });
      }
    
      updateRequestURL(tableData) {
        let options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED);

        if (this.state.groupingFilterValue && this.state.groupingFilterValue.value) {
          options.push({ 'filterByGroupingId': this.state.groupingFilterValue.value})
        }
    
        let params = options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
    
        const currentSearch = this.props.location.search ? this.props.location.search : '?';
    
        if (`?${params}` !== currentSearch) {
          if (this.state.currentHistoryCount > 100) {
            console.error('Exceeded the history count stack of 100.');
            return false;
          }
          this.props.history.push({
            search: `?${params}`,
            state: {
              currentHistoryCount: this.state.currentHistoryCount + 1,
              currentGroupingFilter: this.state.groupingFilterValue,
              searchValue: this.state.searchValue
            }
          });
          return true;
        } else {
          return false;
        }
    }

    updateGroupingFilterValue(newValue) {
      this.setState({
        groupingFilterValue: newValue
      }, () => {
        this.updateRequestURL(this.refs.checklistUsersTable && this.refs.checklistUsersTable.state ? this.refs.checklistUsersTable.state : null);
      });
    }

    doSearch(val) {
      let value = val.target.value
      this.setState({searchValue: value})
      if (this.state.timeout) {
        clearTimeout(this.state.timeout);
      }
      this.state.timeout = setTimeout(() => {
        this.updateSearchValue(value)
      }, 500);
     }
   
     updateSearchValue(val) {
       this.setState({searchValue: val}, () => {
         this.fetchData(this.refs.checklistUsersTable && this.refs.checklistUsersTable.state ? this.refs.checklistUsersTable.state : null);
       });
     }

    renderDeviceGroupings(row) {
        return row.original.deviceGroupings.map(grouping => grouping.name).join(', ');
    }
    
    render() {
        if (this.state.linkTo) {
          return <Redirect push to={{ 
            pathname: this.state.linkTo, 
            state: { 
              backLinkSearch: this.props.location.search,
              searchValue: this.state.searchValue
            }
          }} />;
        }
        
        if (this.state.groupingFilterOptions) {  
          let dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);
          
          return (
              <div className="animated fadeIn">
      
                <div className="row">
                  <PageTitle title={i18next.t('pages.checklist-users.header')}
                            addLinkWithParams={{
                              link: {
                                pathname: "/config/checklist/users/add",
                                state: {
                                  backLinkSearch: this.props.location.search,
                                  searchValue: this.state.searchValue
                                }
                              }
                            }} />
                </div>
                {this.renderMessages()}
      
                <div className="op-content-box">
                  <div className="row">
                  <div className="col-sm-4 pull-right">
                    <Select
                        ref="filterByGroupingSelect"
                        placeholder = {i18next.t('form-labels.filter-by-group')}
                        options={this.state.groupingFilterOptions}
                        isClearable={true}
                        name="selected-filter-by"
                        value={this.state.groupingFilterValue}
                        onChange={this.updateGroupingFilterValue.bind(this)}
                        isSearchable={true}
                        className="business-filter"
                        className="react-select-container "
                        classNamePrefix="react-select"
                    />
                </div>
                    <div className="col-sm-12">
                      <div>
                        <div className="card-block">
                          <div className="react-table-custom">
                            <ReactTable
                              className="-striped -highlight"
                              ref="checklistUsersTable"
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.state.data}
                              pages={this.state.pageCount} // Display the total number of pages
                              loading={this.state.loading} // Display the loading overlay when we need it
                              totalElements={this.state.totalElements}
                              onFetchData={this.fetchData.bind(this)} // Request new data when things change
                              showPaginationTop
                              columns={[
                                          {
                                            Header: i18next.t('table-headers.name'),
                                            accessor: "fullName",
                                            sortable: true,
                                            filterable: true,
                                            Filter: <div className="filter">
                                            <input
                                              style={{width: "100%", margin:"0 auto"}}
                                              value = {this.state.searchValue}
                                              onChange={this.doSearch.bind(this)}
                                              type="text"
                                              name="search"
                                              placeholder="Search by name"
                                              className="table-search"
                                              autoComplete="off"
                                            />
                                          </div>,
                                            minResizeWidth: 50
                                          },
                                          {
                                              Header: i18next.t('table-headers.locations'),
                                              accessor: "id",
                                              Cell: row => (this.renderDeviceGroupings(row)),
                                              sortable: false,
                                              minResizeWidth: 50
                                            },
                                          {
                                            Cell: cell => <RowButton
                                                              allowView = {this.state.viewAllowed}
                                                              allowEdit = {this.state.editAllowed}
                                                              editClick = {this.editLinkClick.bind(this)}
                                                              viewClick={this.viewLinkClick.bind(this)}
                                                              rowId={cell.original.id} />,
                                            sortable: false,
                                            minResizeWidth: 50,
                                            width: 150
                                          }
                                        ]}
                              {...dynamicOptions}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          );
      } else {
        return (
          <div className="loader">{i18next.t('loading')}</div>
        );
      }
    }  
}

export default ChecklistUsers;